import numberImg1 from "gamfi/assets/images/icons/participate-image.png";
import numberImg2 from "gamfi/assets/images/icons/participate-image2.png";
import numberImg3 from "gamfi/assets/images/icons/participate-image3.png";

const data = [
  {
    icon: numberImg1,
    title: "Connect Wallet",
    text: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece",
  },
  {
    icon: numberImg2,
    title: "Claim Tokens",
    text: "Popular belief Ipsum is not simply random text. It has roots in a piece of classical",
  },
  {
    icon: numberImg3,
    title: "Share in Social",
    text: "Belief norem Isum is not simply random text. It has roots in a piece of classical",
  },
];

export default data;
